module.exports = __webpack_public_path__ + "static/media/Estate Hudson King Headboard - 180 cm_White.a17c3548.png";